// Lazysizes
import 'lazysizes';

// Plugins
import noUiSlider from 'nouislider'
import Cookies from 'js-cookie'
import wNumb from './Plugins/wNumb.js'
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider"
import AutoAnimate from '@marcreichel/alpine-auto-animate';
import flatpickr from "flatpickr";
import { Danish } from "flatpickr/dist/l10n/da.js"

window.cookie = Cookies;
window.wNumb = wNumb;
window.rangeSlider = noUiSlider

// Alpine bootup
import Alpine from 'alpinejs';
import Tooltip from "@ryangjchandler/alpine-tooltip";
import intersect from '@alpinejs/intersect'
import persist from '@alpinejs/persist'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import mask from '@alpinejs/mask'

import cartHandler from './AlpineComponents/cartHandler'

window.Alpine = Alpine;

Alpine.plugin(AutoAnimate);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(Tooltip);
Alpine.plugin(mask);

document.addEventListener('alpine:init', () => {
    
    // Tiny slider init
    window.tns = tns;

    // Flatpickr init
    window.flatpickr = flatpickr;
    flatpickr.localize(Danish);

    //var v = new aspnetValidation.ValidationService();
    //v.bootstrap();
    //window.v = v;

    window.getVerificationToken = () => ({
        'RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
    });

    Alpine.store('miniBasket', '');
    Alpine.store('cartHandler', cartHandler);
    Alpine.store('bottomDrawer', '');
    Alpine.store('loanInfo', {
        setCalculatedValues(value) {

            this.totalkreditcost = value.totalkreditcost + ' kr';
            this.kreditcost = value.kreditcost + ' kr';
            this.monthlyPay = value.monthlyPay + ' kr';
            this.debitrente = value.debitrente;
            this.aop = value.aop
            
        },
        setCustomerSettings(a, m) {
            let moneyFormat = wNumb({
                decimals: 0,
                thousand: '.',
                suffix: ' kr.'
            });

            let monthFormat = wNumb({
                decimals: 0,
                suffix: ' mdr.'
            })

            this.amount = moneyFormat.to(a);
            this.months = monthFormat.to(m);
        },
        toggleLoans() {
            this.toggle = true;
        },
        amount: '',
        months: '',
        totalkreditcost: '0',
        kreditcost: 0,
        monthlyPay: '0',
        debitrente: '',
        aop: '',
        toggle: false
    })
})

Alpine.start();

Alpine.plugin(intersect);
Alpine.plugin(persist);


//// aspnet-client-validation bootup
//import { ValidationService } from 'aspnet-client-validation';

//// aspnet-client-validation bootup
//import AspnetClientValidation from "./Plugins/validation.js";
//AspnetClientValidation();